import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from '@reduxjs/toolkit'
import type { Action, Middleware } from '@reduxjs/toolkit'
import type { ThunkAction } from 'redux-thunk'

import logger from 'redux-logger'
import { userSlice } from './userSlice'
import { mainSlice } from './mainSlice'
import { useDispatch, useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import storageSession from 'redux-persist/lib/storage/session'

import { persistReducer, persistStore } from 'redux-persist'

const persistConfig = {
  key: 'root',
  storage: storageSession,
  // whitelist: ['user'],
}

const reducers = combineReducers({
  user: userSlice.reducer,
  main: mainSlice.reducer,
})

const persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware().concat(logger as Middleware),
  //devTools: process.env.NODE_ENV !== "production"
})

export const persistor = persistStore(store)
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
